import {
  Box,
  Button,
  Text,
  TogglerCheckbox,
  useToggle,
} from '@factorialco/deprecated-design-system'

import { ItemProps } from '.'
import ConfigureIncidence from './ConfigureIncidence'

const Item = ({
  title,
  disabled,
  onTogglerChange,
  active,
  onSetValidation,
  needsValidation = false,
  isSettings,
}: ItemProps) => {
  const [open, toggleModal] = useToggle(false)

  return (
    <Box flexDirection="row" gap="s16" alignItems="center">
      <Box flexDirection="row" gap="s8">
        {!isSettings && (
          <Button
            type="secondary"
            disabled={!active}
            onClick={toggleModal(true)}
            iconName="settings"
          />
        )}
        <Box alignSelf="center">
          <TogglerCheckbox value={active} onChange={onTogglerChange} disabled={disabled} />
        </Box>
      </Box>
      <Box>
        <Text.Normal size="300" color="grey800" weight="medium">
          {title}
        </Text.Normal>
      </Box>

      {open && (
        <ConfigureIncidence
          onClose={toggleModal(false)}
          onSubmit={onSetValidation}
          title={title}
          needsValidation={needsValidation}
        />
      )}
    </Box>
  )
}

export default Item
